"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _blockEdit = _interopRequireDefault(require("../../../block-edit"));
var _styled = require("../../../base/styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DiversityItem = function DiversityItem(_ref) {
  var includeOnResume = _ref.includeOnResume,
    diversities = _ref.diversities,
    onClickEdit = _ref.onClickEdit,
    isEdit = _ref.isEdit,
    showPrivate = _ref.showPrivate;
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1B_DIVERSITIES, false);
    },
    title: "My Diversities".concat(includeOnResume ? '' : ' (Private)'),
    color: "#E971E3",
    isEdit: isEdit,
    show: (isEdit || !(0, _isEmpty.default)(diversities)) && (includeOnResume || showPrivate)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, diversities.map(function (diversity) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: JSON.stringify(diversity)
    }, (0, _utils.getDiversityName)(diversity));
  }))));
};
DiversityItem.propTypes = {
  diversities: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  includeOnResume: _propTypes.default.bool.isRequired,
  onClickEdit: _propTypes.default.func.isRequired,
  isEdit: _propTypes.default.bool.isRequired,
  showPrivate: _propTypes.default.bool.isRequired
};
var _default = DiversityItem;
exports.default = _default;